import React, { useEffect, useState } from "react";
import {
  authFetch,
  clearAuthTokens,
  logoutUser,
} from "../../utils/auth";
import { Link, useNavigate } from "react-router-dom";
import "./Admin.css";
import "./AdminHome.css";
import "./AdminHome.mobile.css";

const AdminHome = () => {
  const [username, setUsername] = useState("");
  const [authChecked, setAuthChecked] = useState(false);
  const navigate = useNavigate();

  // ── Auth ─────────────────────────────────────────────────
	useEffect(() => {
	const check = async () => {
		try {
		const res = await authFetch(
			"/api/dashboard/user/"
		);

		if (!res.ok) {
			throw new Error("Authentication failed");
		}

		const data = await res.json();

		setUsername(data.username);
		setAuthChecked(true);

		} catch {
		clearAuthTokens();

		navigate(
			"/login",
			{ replace: true }
		);
		}
	};

	check();
	}, [navigate]);

	const handleLogout = async () => {
	await logoutUser();

	navigate(
		"/login",
		{ replace: true }
	);
	};
  if (!authChecked) return null;

  return (
    <div className="home-page">

      {/* ── HEADER ── */}
      <header className="adm-header">
        <div className="adm-header__left">
          <Link to="/" className="adm-header__back">← SITE</Link>
          <h1 className="adm-header__title">
            ADMIN<span className="adm-header__slash">/</span>HOME
          </h1>
        </div>
        <div className="adm-header__right">
          <span className="adm-header__user">{username}</span>
          <button className="adm-header__logout" onClick={handleLogout}>
            Déconnexion
          </button>
        </div>
      </header>

      {/* ── HERO ── */}
      <section className="home-hero">
        <p className="home-hero__label">Dashboard</p>
        <h2 className="home-hero__title">
          QUE VOULEZ-<br />
          <span>VOUS FAIRE</span><br />
          AUJOURD'HUI ?
        </h2>
        <div className="home-hero__line" />
      </section>

      {/* ── CARTES ── */}
      <section className="home-cards">

        {/* Carte Messages */}
        <Link to="/admin/contact" className="home-card home-card--messages">
          <div className="home-card__num">01</div>
          <div className="home-card__body">
            <p className="home-card__category">Contact</p>
            <h3 className="home-card__title">Voir les<br />messages<br />reçus</h3>
            <p className="home-card__desc">
              Consultez, lisez et répondez aux messages envoyés via le formulaire de contact du site.
            </p>
          </div>
          <div className="home-card__footer">
            <span className="home-card__cta">OUVRIR →</span>
          </div>
          <div className="home-card__accent" />
        </Link>

        {/* Carte Blog */}
        <Link to="/admin/blog" className="home-card home-card--blog">
          <div className="home-card__num">02</div>
          <div className="home-card__body">
            <p className="home-card__category">Blog</p>
            <h3 className="home-card__title">Écrire un<br />article de<br />blog</h3>
            <p className="home-card__desc">
              Rédigez et publiez un nouvel article. Mise en page riche, images, aperçu en temps réel.
            </p>
          </div>
          <div className="home-card__footer">
            <span className="home-card__cta">ÉCRIRE →</span>
          </div>
          <div className="home-card__accent" />
        </Link>

      </section>

      {/* ── FOOTER ── */}
      <footer className="home-footer">
        <span className="home-footer__copy">
          © {new Date().getFullYear()} — Interface d'administration
        </span>
        <span className="home-footer__mark">✦</span>
        <span className="home-footer__copy">Accès restreint</span>
      </footer>

    </div>
  );
};

export default AdminHome;